export const StepButtons = ({
    isStepEditMode,
    setIsStepEditMode,
    setStepValues,
    locale,
    ihm_viewer__dictionary
}) => {
    const isEditingSteps = isStepEditMode;

    const handleValidate = () => setIsStepEditMode(false);

    const handleResetDefaults = () => setStepValues({
        distalMesial: 0.1,
        lingualVestibular: 0.1,
        extrusionIntrusion: 0.1,
        torque: 1,
        tip: 1,
        rotation: 1,
    });

    const handleEnterSettings = () => setIsStepEditMode(true);

    return (
        <div className="left-panel-buttons">
            {isEditingSteps ? (
                <>
                    <button
                        className="collision-button-back"
                        onClick={handleValidate}
                    >
                        {ihm_viewer__dictionary.VALIDATE[locale()]}
                    </button>
                    <button
                        className="left-panel-delete-button"
                        onClick={handleResetDefaults}
                    >
                        🗘
                    </button>
                </>
            ) : (
                <button
                    className="collision-button"
                    onClick={handleEnterSettings}
                >
                    {ihm_viewer__dictionary.SETTINGS[locale()]}
                </button>
            )}
        </div>
    );
};
